/* eslint-disable @typescript-eslint/no-non-null-assertion */

export const USED_AS_SPA = "false" === 'true';
export const SENTRY_DSN = "https://9aa863716f0d44298d5328a31273ade6@sentry.io/1512399" || '';
const SPLIT_IO_API_KEY_STAGING = "n33vr9vfs09671pc90pgi7kvj8q7vvvfvjvd";
const SPLIT_IO_API_KEY_PRODUCTION = "9a44abjpf5r66aq6r9o6426v9n2tg9ko9tah";

// eslint-disable-next-line consistent-return
export default environment => {
  // eslint-disable-next-line default-case
  switch (environment) {
    case 'TEST':
    case 'LOCAL':
    case 'DEVELOPMENT':
      return {
        SPLIT_IO_API_KEY: 'localhost',
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          MAIN_APP: 'https://www.datacamp-staging.com',
          MULTIPLEXER_URL: 'https://sessions.datacamp-staging.com',
          TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
        }
      };
    case 'STAGING':
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_STAGING,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          MAIN_APP: 'https://www.datacamp-staging.com',
          MULTIPLEXER_URL: 'https://sessions.datacamp-staging.com',
          TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
        }
      };
    case 'PRODUCTION':
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_PRODUCTION,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp.com',
          MAIN_APP: 'https://www.datacamp.com',
          MULTIPLEXER_URL: 'https://sessions.datacamp.com',
          TEACH_APP: 'https://teach-api.datacamp.com/teach-app'
        }
      };
  }
};